import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
//import { ActivityHomeComponent } from './pages/activity-home/activity-home.component';
//import { ActivityListComponent } from './pages/activity-list/activity-list.component';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
//import { WbsComponent } from './pages/wbs/wbs.component';
//import { SelectSingleLookupModule } from './components/select-single-lookup/select-single-lookup.module';
//import { ActivityComponent } from './components/activity/activity.component';
//import { DatePickerModule } from './components/date-picker/date-picker.module';
//
//import { DragDropModule } from '@angular/cdk/drag-drop';
//import { ActivitySliderComponent } from './components/activity-slider/activity-slider.component';
import { DataService } from './framework/services/data.service';
import { FormsApiService } from './framework/services/forms-api.service';
import { AiCommandService } from './framework/services/ai-command.service';
//import { FilterSliderComponent } from './components/filter-slider/filter-slider.component';
//import { ActivityListCompComponent } from './components/activity-list-comp/activity-list-comp.component';
//import { StatusLookupModule } from './components/status-lookup/status-lookup.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { TaskDialogModule } from './components/task-dialog/task-dialog.module';
//import { JobCreateDialogModule } from './components/job-create-dialog/job-create-dialog.module';
//import { ActivityActionModule } from './components/activity-action/activity-action.module';
import { AuthGuard } from './framework/authorisation/auth.guard';
import { AuthService } from './framework/authorisation/auth.service';
import { JwtInterceptor } from './framework/authorisation/jwt.interceptor';
import { ConfigService } from './framework/services/config.service';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import localeEnZA from '@angular/common/locales/en-ZA';
import { registerLocaleData } from '@angular/common';
import { DEFAULT_CURRENCY_CODE } from '@angular/core';
import { LocaleService } from './services/locale.service';
import { NgxDaterangepickerBootstrapModule } from 'ngx-daterangepicker-bootstrap';
import { AppState } from './app-state';


export function initApp(configService: ConfigService): (() => Promise<boolean>) {


  try {

    AppModule.companyInfo = {};
    var url = document.location.href;


    var tmp = document.createElement('a');
    tmp.href = url;

    var items = tmp.hostname.split('.');

    var configRequest = new XMLHttpRequest();
    configRequest.open('GET', "appsettings.json", false);  // request application settings synchronous
    configRequest.send(null);
    const configResponse = JSON.parse(configRequest.responseText);

    var apiUrl = configResponse.Connections.apiEndPoint;



    AppModule.instanceInfo = {};
    AppModule.instanceInfo.systemName = "Chronodesk";
    //AppModule.instanceInfo.loginLogo = "chronodesk-fc.svg";
    AppModule.instanceInfo.loginLogo = "CHRONODESK LOGO VARIATIONS_GRADIENT FC LOGO.png";
    //AppModule.instanceInfo.sidebarLogo = "chronodesk-fc-reverse.svg";
    AppModule.instanceInfo.sidebarLogo = "chronodesk2024.png";
    AppModule.instanceInfo.sidebarLogoSmall = "CHRONODESK_FAVICONS_2024_Chronodesk_Favicon_3.svg";

    var systemName = configResponse.SystemName;
    if (systemName != null) AppModule.instanceInfo.systemName = systemName;
    console.log("System Name", systemName);

    var sidebarLogo = configResponse.SidebarLogo;
    if (sidebarLogo != null) AppModule.instanceInfo.sidebarLogo = sidebarLogo;

    var sidebarLogoSmall = configResponse.SidebarLogoSmall;
    if (sidebarLogoSmall != null) AppModule.instanceInfo.sidebarLogoSmall = sidebarLogoSmall;

    var loginLogo = configResponse.LoginLogo;
    if (loginLogo != null) AppModule.instanceInfo.loginLogo = loginLogo;


    var request = new XMLHttpRequest();
    request.open('GET', apiUrl + "/api/Auth/GetCompanyInfo?directory=" + items[0], false);  // request application settings synchronous
    request.send();
    const response = JSON.parse(request.responseText);

    console.log("AppModule.companyInfo", response);

    if (response != null) {

      AppModule.companyInfo = response;
    }

  }
  catch {
  }


  return configService.init();
}


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


export function loggerCallback(logLevel: LogLevel, message: string) {

}

////JB: Chronodesk one
//export function MSALInstanceFactory(): IPublicClientApplication {
//  return new PublicClientApplication({
//    auth: {
//      clientId: '43d83b26-b58e-4354-8fb0-309fdd934b91',
//      authority: 'https://login.microsoftonline.com/6036bd51-a797-4615-9c21-4c0933294a33',
//      /*redirectUri: 'http://localhost:4201/account/ad-login/'*/
//      redirectUri: 'https://app.chronodesk.io/account/ad-login/'
//    },
//    cache: {
//      cacheLocation: BrowserCacheLocation.LocalStorage,
//      storeAuthStateInCookie: isIE, // set to true for IE 11
//    },
//    system: {
//      loggerOptions: {
//        loggerCallback,
//        logLevel: LogLevel.Info,
//        piiLoggingEnabled: false
//      }
//    }
//  });
//}

//JB: Dynamic Productdion One
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: AppModule.companyInfo.AzureClientId,
      authority: AppModule.companyInfo.AzureAuthority,
      redirectUri: AppModule.companyInfo.AzureRedirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}


export function getLocale(): string {

  return LocaleService.localeId;
}

export function getCurrencyCode(): string {
  return LocaleService.currencyCode;
}

// Register the locale data for South Africa
//registerLocaleData(localeEnZA, 'en-ZA');

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    CounterComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    CommonModule,
    RouterModule.forRoot([
      //{ path: '', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: '', loadChildren: () => import('./pages/_layouts/pages/pages-layout.module').then(m => m.PagesLayoutModule), canActivate: [AuthGuard] },
      { path: 'callback', loadChildren: () => import('./pages/_layouts/callback/callback-layout.module').then(m => m.CallbackLayoutModule) },
      { path: 'video', loadChildren: () => import('./pages/_layouts/videos/videos-layout.module').then(m => m.VideosLayoutModule), canActivate: [AuthGuard] },
      { path: 'pages', loadChildren: () => import('./pages/_layouts/pages/pages-layout.module').then(m => m.PagesLayoutModule), canActivate: [AuthGuard] },
      { path: 'account', loadChildren: () => import('./pages/_layouts/account/account-layout.module').then(m => m.AccountLayoutModule) },
      { path: 'print', loadChildren: () => import('./pages/_layouts/print/print-layout.module').then(m => m.PrintLayoutModule), canActivate: [AuthGuard] },
      { path: 'c/:company', loadChildren: () => import('./pages/_layouts/client/client-layout.module').then(m => m.ClientLayoutModule) },
      { path: 'print/:company', loadChildren: () => import('./pages/_layouts/print/print-layout.module').then(m => m.PrintLayoutModule), canActivate: [AuthGuard] },
    ]),

    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    ReactiveFormsModule,
    ReactiveFormsModule,
    MsalModule,
    NgxDaterangepickerBootstrapModule.forRoot()
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [ConfigService],
      multi: true
    },
    DataService,
    FormsApiService,
    AiCommandService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    AuthGuard,
    {
      provide: LOCALE_ID, useValue: getLocale(),
    },
    {
      provide: DEFAULT_CURRENCY_CODE, useValue: getCurrencyCode(),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {

  // Delegating to AppState breaks the BaseComponent → AppModule circular dependency.
  // These getters/setters maintain backward-compatible access via AppModule.instanceInfo
  // and AppModule.companyInfo while the canonical store lives in app-state.ts.
  static get companyInfo(): any { return AppState.companyInfo; }
  static set companyInfo(v: any) { AppState.companyInfo = v; }

  static get instanceInfo(): any { return AppState.instanceInfo; }
  static set instanceInfo(v: any) { AppState.instanceInfo = v; }

}
